import { ChainId, WBNB, ERC20Token } from '@pancakeswap/sdk'
import { BUSD_BSC, CAKE_MAINNET, USDC_BSC, USDT_BSC } from './common'

export const bscTokens = {
  wbnb: WBNB[ChainId.BSC],
  // bnb here points to the wbnb contract. Wherever the currency BNB is required, conditional checks for the symbol 'BNB' can be used
  bnb: new ERC20Token(
    ChainId.BSC,
    '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    18,
    'POL',
    'Polygon Ecosystem Token',
    'https://polygon.technology/',
  ),
  cake: CAKE_MAINNET,
  busd: BUSD_BSC,
  dai: new ERC20Token(
    ChainId.BSC,
    '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
    18,
    'DAI',
    'Dai Stablecoin',
    'https://www.makerdao.com/',
  ),
  usdt: USDT_BSC,
  sd: new ERC20Token(
    ChainId.BSC,
    '0x1d734A02eF1e1f5886e66b0673b71Af5B53ffA94',
    18,
    'SD',
    'Stader (PoS)',
    'https://www.staderlabs.com/',
  ),
  usdc: USDC_BSC,
  syrup: new ERC20Token(
    ChainId.BSC,
    '0x7cbbC91c05c64c5E5b12Da6F090F8f11480deA64',
    18,
    'PLAXBAR',
    'PlasaBar Token',
    'https://pancakeswap.finance/',
  ),
  pay: new ERC20Token(
    ChainId.BSC,
    '0x7Ab2b041E120DcA2a40d8F9524B618A854d3A617',
    8,
    'PAY',
    'PLAXPAY',
    'https://www.plaxpay.app/',
  ),
  tpay: new ERC20Token(
    ChainId.BSC,
    '0x8DF4c954C51E5ccBa51b8a21cC3fF6347760b31a',
    18,
    'TPAY',
    'PAYMATIC',
    'https://www.paymatic.cloud/',
  ),
  sme: new ERC20Token(
    ChainId.BSC,
    '0xcD9c386c9CE5987A8336C4Db5c6A17750ea0e339',
    8,
    'SME',
    'WESMEUP',
    'https://www.wesmeup.net/',
  ),
  cron: new ERC20Token(
    ChainId.BSC,
    '0xC5112195a19151Cf93570d6a400DA53aaf631626',
    18,
    'CRON',
    'CRYPTOPRENEUR',
    'https://www.cryptopreneur.vip/',
  ),
  idrt: new ERC20Token(
    ChainId.BSC,
    '0x554cd6bdD03214b10AafA3e0D4D42De0C5D2937b',
    6,
    'IDRT',
    'RUPIAH TOKEN',
    'https://rupiahtoken.com',
  ),
  idrx: new ERC20Token(
    ChainId.BSC,
    '0x649a2DA7B28E0D54c13D5eFf95d3A660652742cC',
    0,
    'IDRX',
    'IDRX',
    'https://idrx.co',
  ),
  xidr: new ERC20Token(
    ChainId.BSC,
    '0x2c826035c1C36986117A0e949bD6ad4baB54afE2',
    6,
    'XIDR',
    'XIDR',
    'https://www.straitsx.com/id/xidr',
  ),
  xsgd: new ERC20Token(
    ChainId.BSC,
    '0xDC3326e71D45186F113a2F448984CA0e8D201995',
    6,
    'XSGD',
    'XSGD',
    'https://www.straitsx.com/id/xsgd',
  ),
  usdcoin: new ERC20Token(
    ChainId.BSC,
    '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
    6,
    'USDC',
    'USD Coin',
    'https://mapper.polygon.technology/',
  ),
  quick: new ERC20Token(
    ChainId.BSC,
    '0xB5C064F955D8e7F38fE0460C556a72987494eE17',
    18,
    'QUICK',
    'QUICKSWAP',
    'https://quickswap.exchange',
  ),
  aave: new ERC20Token(
    ChainId.BSC,
    '0xD6DF932A45C0f255f85145f286eA0b292B21C90B',
    18,
    'AAVE',
    'AAVE',
    'https://aave.com',
  ),
  df: new ERC20Token(
    ChainId.BSC,
    '0x08C15FA26E519A78a666D19CE5C646D55047e0a3',
    18,
    'DF',
    'DFORCE',
    'https://dforce.network/',
  ),
  usx: new ERC20Token(
    ChainId.BSC,
    '0xCf66EB3D546F0415b368d98A95EAF56DeD7aA752',
    18,
    'USX',
    'DFORCE USD',
    'https://dforce.network/',
  ),
  uni: new ERC20Token(
    ChainId.BSC,
    '0xb33EaAd8d922B1083446DC23f610c2567fB5180f',
    18,
    'UNI',
    'UNISWAP',
    'https://app.uniswap.org/',
  ),
  sushi: new ERC20Token(
    ChainId.BSC,
    '0x0b3F868E0BE5597D5DB7fEB59E1CADBb0fdDa50a',
    18,
    'SUSHI',
    'SUSHISWAP',
    'https://www.sushi.com/',
  ),
  render: new ERC20Token(
    ChainId.BSC,
    '0x61299774020dA444Af134c82fa83E3810b309991',
    18,
    'RENDER',
    'RENDER',
    'https://rendernetwork.com/',
  ),
  mana: new ERC20Token(
    ChainId.BSC,
    '0xA1c57f48F0Deb89f569dFbE6E2B7f46D33606fD4',
    18,
    'MANA',
    'DECENTRALAND',
    'https://decentraland.org/',
  ),
  nexo: new ERC20Token(
    ChainId.BSC,
    '0x41b3966B4FF7b427969ddf5da3627d6AEAE9a48E',
    18,
    'NEXO',
    'NEXO',
    'https://nexo.com/',
  ),
  knc: new ERC20Token(
    ChainId.BSC,
    '0x1C954E8fe737F99f68Fa1CCda3e51ebDB291948C',
    18,
    'KNC',
    'KYBER NETWORK CRYSTAL',
    'https://kyber.network',
  ),
  crv: new ERC20Token(
    ChainId.BSC,
    '0x172370d5Cd63279eFa6d502DAB29171933a610AF',
    18,
    'CRV',
    'CURVE DAO',
    'https://www.curve.fi/',
  ),
  rr: new ERC20Token(
    ChainId.BSC,
    '0x91Faa9fA243EaF35981f5563ec67e9bF0d8DFAEE',
    18,
    'RR',
    'RFIDR',
    'https://www.rfidr.net/',
  ),
  rfm: new ERC20Token(
    ChainId.BSC,
    '0x04488963B02447B1ba926DBa6AD3a5f57fD855f1',
    18,
    'RFM',
    'RFIDM',
    'https://www.rfidr.net/',
  ),
  rfc: new ERC20Token(
    ChainId.BSC,
    '0x9947d87c811e6033A1eEAFf3D25f6b4A94A8A1a7',
    18,
    'RFC',
    'RFIDC',
    'https://www.rfidr.net/',
  ),
  rfx: new ERC20Token(
    ChainId.BSC,
    '0x8439cc930D330427D8A4BBABC335F5927A52fa87',
    18,
    'RFX',
    'RFIDX',
    'https://www.rfidr.net/',
  ),
  fif: new ERC20Token(
    ChainId.BSC,
    '0xbaEF7137D3cEC6282a83dd954eA6376d464f7780',
    18,
    'FIF',
    'FREEDOM INITIAL FUND',
    'https://linktr.ee/fifcamp_b2b',
  ),
  bcore: new ERC20Token(
    ChainId.BSC,
    '0xA830a38CeAC7BFe3568D229945A45121730fbb91',
    18,
    'BCORE',
    'Bulldog Core',
    'https://www.bullclub.site/',
  ),
  brc: new ERC20Token(
    ChainId.BSC,
    '0x580b956f9828225647C154E13569A2409e0AAd27',
    18,
    'BRC',
    'Bulldog Racing Club',
    'https://fairlaunch.cloud/bullclub/?refId=0x178A29F79eD22f9cc4fE1FAB1Dc9c095dC58d844/',
  ),
  burn: new ERC20Token(
    ChainId.BSC,
    '0xF84F0C7D675728D7fadD0D9dd97AbE26EB14642c',
    18,
    'BURN',
    'BULLDOG REBORN',
    'https://www.bullclub.site/',
  ),
  ball: new ERC20Token(
    ChainId.BSC,
    '0xCC135a9d941d2a1f40d55a04eb6A90d9835dA7d7',
    18,
    'BALL',
    'BULLDOG ALLIANCE',
    'https://linktr.ee/useball',
  ),
  brand: new ERC20Token(
    ChainId.BSC,
    '0xb0de690CA7C204608062765507e280d0163D452C',
    18,
    'BRAND',
    'BULLDOG BRAND',
    'https://fairlaunch.cloud/brandswap/?refId=0x178A29F79eD22f9cc4fE1FAB1Dc9c095dC58d844/',
  ),
  vip: new ERC20Token(
    ChainId.BSC,
    '0xffe481A8214d6eB04CFC5Df28feCFEFdacBad37e',
    18,
    'VIP',
    'VIPool',
    'https://www.bcore.site/',
  ),
  cmr: new ERC20Token(
    ChainId.BSC,
    '0xA9919Eae41600561823EECc766F8ee66834A356D',
    18,
    'CMR',
    'CMiner',
    'https://fairlaunch.cloud/CMiner/',
  ),
  wbtc: new ERC20Token(
    ChainId.BSC,
    '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
    8,
    'BTC',
    'Wrapped BTC',
    'https://www.wbtc.network/',
  ),
  tbtc: new ERC20Token(
    ChainId.BSC,
    '0x236aa50979D5f3De3Bd1Eeb40E81137F22ab794b',
    18,
    'tBTC',
    'tBTC',
    'https://www.threshold.network/',
  ),
  weth: new ERC20Token(
    ChainId.BSC,
    '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    18,
    'ETH',
    'Wrapped Ether',
    'https://ethereum.org/',
  ),
  wbsc: new ERC20Token(
    ChainId.BSC,
    '0xeCDCB5B88F8e3C15f95c720C51c71c9E2080525d',
    18,
    'BNB',
    'Wrapped BNB',
    'https://www.bnbchain.org/en',
  ),
  sol: new ERC20Token(
    ChainId.BSC,
    '0xd93f7E271cB87c23AaA73edC008A79646d1F9912',
    9,
    'SOL',
    'SOLANA',
    'https://solana.com/',
  ),
  avax: new ERC20Token(
    ChainId.BSC,
    '0x2C89bbc92BD86F8075d1DEcc58C7F4E0107f286b',
    18,
    'AVAX',
    'Avalanche',
    'https://www.avax.network/',
  ),
  link: new ERC20Token(
    ChainId.BSC,
    '0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39',
    18,
    'LINK',
    'ChainLink',
    'https://chain.link/',
  ),
  inch: new ERC20Token(
    ChainId.BSC,
    '0x9c2C5fd7b07E95EE044DDeba0E97a665F142394f',
    18,
    '1INCH',
    '1INCH',
    'https://1inch.io/',
  ),
  shib: new ERC20Token(
    ChainId.BSC,
    '0x6f8a06447Ff6FcF75d803135a7de15CE88C1d4ec',
    18,
    'SHIB',
    'SHIBA INU',
    'https://shibatoken.com/',
  ),
  bonk: new ERC20Token(
    ChainId.BSC,
    '0xe5B49820e5A1063F6F4DdF851327b5E8B2301048',
    5,
    'BONK',
    'BONK',
    'https://bonkcoin.com/',
  ),
  cro: new ERC20Token(
    ChainId.BSC,
    '0xAdA58DF0F643D959C2A47c9D4d4c1a4deFe3F11C',
    8,
    'CRO',
    'CRONOS',
    'https://cronos-pos.org/',
  ),
  woo: new ERC20Token(
    ChainId.BSC,
    '0x1B815d120B3eF02039Ee11dC2d33DE7aA4a8C603',
    18,
    'WOO',
    'WOO',
    'https://woo.org/',
  ),
  elon: new ERC20Token(
    ChainId.BSC,
    '0xE0339c80fFDE91F3e20494Df88d4206D86024cdF',
    18,
    'ELON',
    'Dogelon Mars',
    'https://dogelonmars.com/',
  ),
  aro: new ERC20Token(
    ChainId.BSC,
    '0xa7D3aA3206425EeC18D9C8bC7A8b7ee922666bdF',
    18,
    'ARO',
    'AroLiex',
    'https://aroliex.co/',
  ),
  pps: new ERC20Token(
    ChainId.BSC,
    '0x5e4d5A1C3470d38b030af2AeA2ADA046Fc34cac6',
    18,
    'PPS',
    'Private Pool Share',
    'https://polygonscan.com/token/0x5e4d5a1c3470d38b030af2aea2ada046fc34cac6#code',
  ),
  btz: new ERC20Token(
    ChainId.BSC,
    '0x67F9DD41bbc9CECb751Ff28Ea0e9E3c2dd15526c',
    18,
    'BTZ',
    'BITZYX',
    'https://polygonscan.com/token/0x67F9DD41bbc9CECb751Ff28Ea0e9E3c2dd15526c#code',
  ),
  btfx: new ERC20Token(
    ChainId.BSC,
    '0x19A16622368cB9E63D6E919ee6C33e42930D563a',
    18,
    'BTFX',
    'BITFRIX',
    'https://xpoolcamp.xyz/',
  ),
  xpool: new ERC20Token(
    ChainId.BSC,
    '0x1Dc357e57F491deC226b8Afe476244f678eB739D',
    18,
    'XPOOL',
    'FIXPOOL',
    'https://xpoolcamp.xyz/',
  ),
  dpool: new ERC20Token(
    ChainId.BSC,
    '0xc718e7fbaE39Ab1ff94BF9cE12F88C9B5254EfE5',
    18,
    'DPOOL',
    'CrowdPool DAO',
    'https://xpoolcamp.xyz/',
  ),
  dshare: new ERC20Token(
    ChainId.BSC,
    '0x307d68e976FA7E9d6C14119f8989D382FDe028c7',
    18,
    'DSHARE',
    'CrowdShare DAO',
    'https://xpoolcamp.xyz/',
  ),
  poin: new ERC20Token(
    ChainId.BSC,
    '0x793cD1f33C15dd4d0481ceF4B757517363C9625d',
    18,
    'POIN',
    'PoinChain',
    'https://fairlaunch.vip/Poinchain-DePIN/',
  ),
  pos: new ERC20Token(
    ChainId.BSC,
    '0x15F0921f024011bB881Cf1A95a9D62897fdf102e',
    18,
    'POS',
    'PoinCash',
    'https://fairlaunch.vip/Poinchain-DePIN/',
  ),
  pin: new ERC20Token(
    ChainId.BSC,
    '0x32d0eA50bDb94a3D1CAC47DE3cF2De5B324f45a5',
    18,
    'PIN',
    'POINTY',
    'https://fairlaunch.vip/PoinEquity/',
  ),
  pot: new ERC20Token(
    ChainId.BSC,
    '0x1434D2F7F0Ce7D3bC9018bD305fb88a9C0Db06b4',
    18,
    'POT',
    'POIN HARVEST',
    'https://fairlaunch.vip/PoinEquity/',
  ),
  zap: new ERC20Token(
    ChainId.BSC,
    '0x6b7682a9fdA1d482A3779C9489DC62437BB58945',
    18,
    'ZAP',
    'ZELTSPHY',
    'https://fairlaunch.vip/getgold/',
  ),
  bring: new ERC20Token(
    ChainId.BSC,
    '0x199a1B6528a2F893e7eCe7e1b3Bd7A4E18c76D9A',
    18,
    'BRING',
    'Blockstring',
    'https://fairlaunch.vip/tringme/',
  ),
  aura: new ERC20Token(
    ChainId.BSC,
    '0x2a12ffDb78Ad627F1a78cA96964eef58b36Dc9c8',
    18,
    'AURA',
    'AZZURAZZA',
    'https://linktr.ee/aurasupport',
  ),
  eta: new ERC20Token(
    ChainId.BSC,
    '0xD95B9B888aF76Dd918Cc33346B08d461512e4ba3',
    18,
    'ETA',
    'EXTRADE',
    'https://extrade.cfd/',
  ),
  tp: new ERC20Token(
    ChainId.BSC,
    '0xB63944e1F1ec6B032475D5Aa542380748e822bD0',
    18,
    'TP',
    'TRADE POOL',
    'https://fairlaunch.cloud/extrade/',
  ),
  get: new ERC20Token(
    ChainId.BSC,
    '0x4a24F93c4416A5a2A36ce8fA6925198198f4EF79',
    18,
    'GET',
    'GIFT EXTRADE',
    'https://linktr.ee/extradeview',
  ),
  bcatt: new ERC20Token(
    ChainId.BSC,
    '0x4A780Bb9D55173426f77D494aA8645273653924E',
    18,
    'BCATT',
    'Boss Cat',
    'https://www.bcatt.fun/',
  ),
  daz: new ERC20Token(
    ChainId.BSC,
    '0xB5f6ca3CDC4d42A57eF85f22Ca98AD4D222D7F4E',
    18,
    'DAZ',
    'BITZAURA',
    'https://www.bitzaura.org/',
  ),
  dax: new ERC20Token(
    ChainId.BSC,
    '0x78Dcb158C18cFF931D188Fe179128e5A8068aE8d',
    18,
    'DAX',
    'BITZAURA-X',
    'https://www.bitzaura.org/',
  ),
  dca: new ERC20Token(
    ChainId.BSC,
    '0xD079128bb5D552E5AA310e252aF535cF0572943D',
    18,
    'DCA',
    'BITZAURA CAMP',
    'https://www.bitzaura.org/',
  ),
  dass: new ERC20Token(
    ChainId.BSC,
    '0xda432286FEd68F40f5aF28F1E005b2378146B8Cc',
    18,
    'DASS',
    'BitZaura Association',
    'https://www.bitzaura.org/',
  ),
  dgold: new ERC20Token(
    ChainId.BSC,
    '0x7aE71763B5Cc70BA3932D05352Da3Af591ed4fEa',
    18,
    'DGOLD',
    'BitZaura Gold',
    'https://www.bitzaura.org/',
  ),
  paxg: new ERC20Token(
    ChainId.BSC,
    '0x553d3D295e0f695B9228246232eDF400ed3560B5',
    18,
    'PAXG',
    'PAX Gold',
    'https://paxos.com/paxgold/',
  ),
  xaut: new ERC20Token(
    ChainId.BSC,
    '0xF1815bd50389c46847f0Bda824eC8da914045D14',
    6,
    'XAUT0',
    'Tether Gold',
    'https://usdt0.to/gold',
  ),
  vnxau: new ERC20Token(
    ChainId.BSC,
    '0xC8bB8eDa94931cA2F20EF43eA7dBD58E68400400',
    18,
    'VNXAU',
    'VNX Gold',
    'https://vnx.li/gold/',
  ),
  cpoin: new ERC20Token(
    ChainId.BSC,
    '0x37aDC8f969b63B8bBD025D10D03900C5cd9DD367',
    0,
    'CPOIN',
    'CLABS REWARD',
    'https://www.cpoin.net/',
  ),
  cpoinx: new ERC20Token(
    ChainId.BSC,
    '0xE7A3eEDDd6c4F339D4219aFBAE5605CA3DF9DDD1',
    18,
    'CPOIN-X',
    'CLABS POOL',
    'https://www.cpoin.net/',
  ),
  btf: new ERC20Token(
    ChainId.BSC,
    '0x9b3d2aFc6fDfeF566a224E2786bAfC854fAf6800',
    18,
    'BTF',
    'Bitfind',
    'https://bitfind.co',
  ),
  ctf: new ERC20Token(
    ChainId.BSC,
    '0x2eB8556dB957a0C9394cedE2f5B11064824Dd060',
    0,
    'CTF',
    'CrowdTech Fund',
    'https://bitfind.vip',
  ),
  btfc: new ERC20Token(
    ChainId.BSC,
    '0x2721098562f5b3dc79917730C2646877F5F374F9',
    18,
    'BTFC',
    'Bitfind Camp',
    'https://bitfind.vip',
  ),
  dapps: new ERC20Token(
    ChainId.BSC,
    '0xC8C16304f6B722F910fb3A74bee55F7F4Dfd36dF',
    18,
    'DAPPS',
    'Defi Project',
    'https://bitfind.vip',
  ),
  rsi: new ERC20Token(
    ChainId.BSC,
    '0x467C3603BEE6F43e9497afA93720d55586213dFE',
    18,
    'RSI',
    'Real Project Finance',
    'https://bitfind.vip',
  ),
  btgs: new ERC20Token(
    ChainId.BSC,
    '0x230f5A4dC8A12698bC65373a47061A50C270D343',
    18,
    'BTGS',
    'BitGands',
    'https://bitfind.co',
  ),
  btps: new ERC20Token(
    ChainId.BSC,
    '0xCcdc94871f1945F8eE75369e14E7D7f7edD371A7',
    18,
    'BTPS',
    'BitParts',
    'https://bitfind.co',
  ),
  plaxusdt: new ERC20Token(
    ChainId.BSC,
    '0x8ae534F07f08422d00Ed00a2Be1335e411Fb9DA0',
    18,
    'PLAXusdt',
    'PLAX-USDT LP',
    'https://plaxswap.io',
  ),
  payusdt: new ERC20Token(
    ChainId.BSC,
    '0x7Fa11bb242CbBa853f634BEF02Fc24A3A13f916d',
    18,
    'PAYusdt',
    'PAY-USDT LP',
    'https://www.plaxpay.app/',
  ),
  smeusdt: new ERC20Token(
    ChainId.BSC,
    '0xB4C4Cd512d60F0E589fBcC58353C1e6225f9a1BB',
    18,
    'SMEusdt',
    'SME-USDT LP',
    'https://www.wesmeup.net/',
  ),
  ppsusdt: new ERC20Token(
    ChainId.BSC,
    '0x659130cE9097E078bc1DDd03703B7d4ed95EBf57',
    18,
    'PPSusdt',
    'PPS-USDT LP',
    'https://polygonscan.com/token/0x659130cE9097E078bc1DDd03703B7d4ed95EBf57',
  ),
  btfxusdt: new ERC20Token(
    ChainId.BSC,
    '0xF5551B1Ef3E39Ed913e43b6054da1e86C69BF162',
    18,
    'BTFXusdt',
    'BTFX-USDT LP',
    'https://xpoolcamp.xyz/',
  ),
  doa: new ERC20Token(
    ChainId.BSC,
    '0x058E73a591FF67ed31D92679db27950eb2546ca1',
    18,
    'DOA',
    'ALIRI',
    'https://aliri.org/',
  ),
  alifi: new ERC20Token(
    ChainId.BSC,
    '0x38e009e25A3B6459345e9c07B93ea41E05AC0990',
    18,
    'ALIFI',
    'ALIRI FINANCE',
    'https://aliri.vip/',
  ),
  alicia: new ERC20Token(
    ChainId.BSC,
    '0x1B6e0561f053830e34349111af458Dc130937928',
    18,
    'ALICIA',
    'ALIRI CREATIVE INDUSTRY',
    'https://aliri.vip/',
  ),
  farm: new ERC20Token(
    ChainId.BSC,
    '0x4490d8Dca8a1dbD10c084bFe8EA286c7fa62373A',
    18,
    'FARM',
    'FREEDOM AUTO REVSHARE',
    'https://freetech.site',
  ),
  face: new ERC20Token(
    ChainId.BSC,
    '0xe9716d7D7248ad22Ac94Fb36DC28Bbbf45E11958',
    18,
    'FACE',
    'FREEDOM CROWDFUNDING EXPERT',
    'https://freetech.site',
  ),
  fgold: new ERC20Token(
    ChainId.BSC,
    '0x38A33Cf60164EaC333400aB0ee7DeeBe92f968dB',
    18,
    'FGOLD',
    'FREEGOLD',
    'https://polygonscan.com/token/0x38A33Cf60164EaC333400aB0ee7DeeBe92f968dB',
  ),
  goidr: new ERC20Token(
    ChainId.BSC,
    '0x0a40ff165736f5989e9F40fFbEd24A640c760754',
    18,
    'GOIDR',
    'Gold Indonesia Republic',
    'https://goidr.co.id/',
  ),
  clk: new ERC20Token(
    ChainId.BSC,
    '0x1EdC86d411AD224f97b6Ad89C4446683C1b0BAaE',
    8,
    'CLK',
    'COINLUCK',
    'https://coinluck.biz/',
  ),
  tba: new ERC20Token(
    ChainId.BSC,
    '0x25481b64c8733475fD17C57e24082Ef938cc40D5',
    18,
    'TBA',
    'THUBA',
    'https://coinluck.biz/',
  ),
  rca: new ERC20Token(
    ChainId.BSC,
    '0x4042bA2085eDfA4b68106b2eec5d5007F1D36DdE',
    18,
    'RCA',
    'RECOIN ASSET',
    'https://recoins.org/',
  ),
  rcr: new ERC20Token(
    ChainId.BSC,
    '0xfB70D564b875A9745a956E135D69e70B59C3905B',
    18,
    'RCR',
    'RECOIN RENT',
    'https://recoins.org/',
  ),
  vindex: new ERC20Token(
    ChainId.BSC,
    '0x9cE83AECC84836d3a95E63a48664Eb82a369960b',
    18,
    'VINDEX',
    'VINDEX',
    'https://polygonscan.com/token/0x9cE83AECC84836d3a95E63a48664Eb82a369960b#code',
  ),
  vreedex: new ERC20Token(
    ChainId.BSC,
    '0x931ea97a2E2baB7571CE9C1B6b8148a53f8997bD',
    18,
    'VREEDEX',
    'VREEDEX',
    'https://polygonscan.com/token/0x931ea97a2E2baB7571CE9C1B6b8148a53f8997bD#code',
  ),
  yuhuu: new ERC20Token(
    ChainId.BSC,
    '0x613B617dBb9fC94Bc13febf7113AE8fa1C678cE1',
    18,
    'YUHUU',
    'YUHUU',
    'https://polygonscan.com/token/0x613B617dBb9fC94Bc13febf7113AE8fa1C678cE1#code',
  ),
  list: new ERC20Token(
    ChainId.BSC,
    '0x9ffAEb136E3793B5B9D1E3a49012D55D22E7Fa3f',
    18,
    'LIST',
    'LIQUD STAKE',
    'https://liquidstake.net',
  ),

}
